import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const CorePickerTwinkle: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M12.3458 12.3438H6.17188v6.1741h6.17392v-6.1741ZM18.5255 6.17188h-6.1739v6.17422h6.1739V6.17188Z" />
        <path d="M6.17391 6.17188H0v6.17422h6.17391V6.17188Z" />
        <path d="M12.3458 0H6.17188v6.17419h6.17392V0Z" />
      </g>
    </svg>
  </IconWrap>
);
CorePickerTwinkle.displayName = 'CorePickerTwinkle';

export default CorePickerTwinkle;
